import * as React from 'react';
const SvgServerNetwork = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M18.8 8.04C18.72 8 18.61 8 18.4 8h-.8c-.21 0-.32 0-.4.04-.07.04-.13.09-.16.16-.04.08-.04.19-.04.4v.8c0 .21 0 .32.04.4.04.07.09.13.16.16.08.04.19.04.4.04h.8c.21 0 .32 0 .4-.04.07-.04.13-.09.16-.16.04-.08.04-.19.04-.4v-.8c0-.21 0-.32-.04-.4a.35.35 0 0 0-.16-.16M5.25 8h.5a.25.25 0 0 1 .25.25v5.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-5.5A.25.25 0 0 1 5.25 8M7.75 8h-.5a.25.25 0 0 0-.25.25v5.5c0 .138.112.25.25.25h.5a.25.25 0 0 0 .25-.25v-5.5A.25.25 0 0 0 7.75 8M9.25 8h.5a.25.25 0 0 1 .25.25v5.5a.25.25 0 0 1-.25.25h-.5a.25.25 0 0 1-.25-.25v-5.5A.25.25 0 0 1 9.25 8"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M21.71 6.47c-.26-.51-.67-.92-1.18-1.18C19.95 5 19.2 5 17.68 5H6.32c-1.51 0-2.27 0-2.85.29-.5.26-.92.68-1.18 1.18C2 7.05 2 7.8 2 9.32v3.36c0 1.51 0 2.27.29 2.85.26.51.67.92 1.18 1.18.58.29 1.33.29 2.85.29H11v1.268a2 2 0 0 0-.732.732H4.64c-.224 0-.336 0-.422.044a.4.4 0 0 0-.174.174C4 19.304 4 19.416 4 19.64v.72c0 .224 0 .336.044.422a.4.4 0 0 0 .174.174c.086.044.198.044.422.044h5.628a2 2 0 0 0 3.464 0h5.628c.224 0 .336 0 .422-.044a.4.4 0 0 0 .174-.174c.044-.086.044-.198.044-.422v-.72c0-.224 0-.336-.044-.422a.4.4 0 0 0-.174-.174C19.696 19 19.584 19 19.36 19h-5.628a2 2 0 0 0-.732-.732V17h4.68c1.51 0 2.27 0 2.85-.29.51-.26.92-.67 1.18-1.18.29-.58.29-1.33.29-2.85V9.32c0-1.51 0-2.27-.29-2.85M20 12.66c0 .84 0 1.7-.1 1.88-.08.16-.22.28-.38.36-.19.09-1.1.09-1.98.09H6.46c-.88 0-1.79 0-1.98-.09a.83.83 0 0 1-.38-.36C4 14.36 4 13.5 4 12.66V9.33c0-.84 0-1.7.1-1.88.08-.16.22-.28.38-.36C4.67 7 5.58 7 6.46 7h11.08c.88 0 1.79 0 1.98.09.17.08.3.21.38.36.1.18.1 1.04.1 1.88z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgServerNetwork;
